"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typography = void 0;
exports.typography = {
    display_lg: {
        fontFamily: 'inherit',
        fontWeight: '400',
        fontSize: '3.6875rem',
        letterSpacing: '0',
    },
    display_md: {
        fontFamily: 'inherit',
        fontWeight: '400',
        fontSize: '2.9375rem',
        letterSpacing: '0',
    },
    display_sm: {
        fontFamily: 'inherit',
        fontWeight: '400',
        fontSize: '2.5rem',
        letterSpacing: '0',
    },
    headline_lg: {
        fontFamily: 'inherit',
        fontWeight: '400',
        fontSize: '2.0625rem',
        letterSpacing: '0.0025em',
    },
    headline_md: {
        fontFamily: 'inherit',
        fontWeight: '400',
        fontSize: '1.4375rem',
        letterSpacing: '0',
    },
    headline_sm: {
        fontFamily: 'inherit',
        fontWeight: '500',
        fontSize: '1.1875rem',
        letterSpacing: '0.0015em',
    },
    title_lg: {
        fontFamily: 'inherit',
        fontWeight: '500',
        fontSize: '1.4375rem',
        letterSpacing: '0',
    },
    title_md: {
        fontFamily: 'inherit',
        fontWeight: '500',
        fontSize: '1rem',
        letterSpacing: '0.0015em',
    },
    title_sm: {
        fontFamily: 'inherit',
        fontWeight: '500',
        fontSize: '0.875rem',
        letterSpacing: '0.001em',
    },
    body_md: {
        fontFamily: 'inherit',
        fontWeight: '400',
        fontSize: '1rem',
        letterSpacing: '0.005em',
    },
    body_sm: {
        fontFamily: 'inherit',
        fontWeight: '400',
        fontSize: '0.875rem',
        letterSpacing: '0.0025em',
    },
    body_sm_strike: {
        fontFamily: 'inherit',
        fontWeight: '400',
        fontSize: '0.875rem',
        letterSpacing: '0.0025em',
        textDecorationLine: 'line-through',
    },
    button: {
        fontFamily: 'inherit',
        fontWeight: '500',
        fontSize: '0.875rem',
        letterSpacing: '0.25px',
    },
    caption_overline: {
        fontFamily: 'inherit',
        fontWeight: '400',
        fontSize: '0.75rem',
        letterSpacing: '0.004em',
    },
    caption_overline_medium: {
        fontFamily: 'inherit',
        fontWeight: '500',
        fontSize: '0.75rem',
        letterSpacing: '0.004em',
    },
    price: {
        fontFamily: 'inherit',
        fontWeight: '500',
        fontSize: '0.813rem',
        letterSpacing: '0.004em',
    },
    tip_single_line_percentage: {
        fontFamily: 'inherit',
        fontWeight: '600',
        fontSize: '1rem',
        letterSpacing: '0.004em',
        lineHeight: '1.4rem',
    },
    tip_single_line_multi_line_top_currency_unit: {
        fontFamily: 'inherit',
        fontWeight: '400',
        fontSize: '0.5rem',
        letterSpacing: '0.004em',
        lineHeight: '0.7rem',
    },
    tip_single_line_multi_line_top_currency_value: {
        fontFamily: 'inherit',
        fontWeight: '600',
        fontSize: '0.75rem !important',
        letterSpacing: '0.004em',
        lineHeight: '1.05rem',
    },
    tip_multi_line_top_line_percentage: {
        fontFamily: 'inherit',
        fontWeight: '600',
        fontSize: '0.75rem',
        letterSpacing: '0.004em',
        lineHeight: '1.05rem',
    },
    tip_multi_line_bottom_line_percentage: {
        fontFamily: 'inherit',
        fontWeight: '400',
        fontSize: '0.688rem',
        letterSpacing: '0.004em',
        lineHeight: '0.782rem',
    },
    tip_multi_line_bottom_line_currency_unit: {
        fontFamily: 'inherit',
        fontWeight: '400',
        fontSize: '0.5rem',
        letterSpacing: '0.004em',
        lineHeight: '0.7rem',
    },
    tip_multi_line_bottom_line_currency_value: {
        fontFamily: 'inherit',
        fontWeight: '400',
        fontSize: '0.75rem !important',
        letterSpacing: '0.004em',
        lineHeight: '0.963rem',
    },
};
